export const pa = {
    addPA: null,
    getPAs: null,
    resumePA: null,
}